import React from "react";
import { Section, H1, H2, ImagesSection, DisclaimerSection } from "./styles";
import WitSoccerLogo from "../../assets/img/witsoccer-logo.png";
import GooglePlay from "../../assets/img/google-play.png";
import AppleStore from "../../assets/img/apple-store.png";

export default function SectionDownload() {
  return (
    <Section>
      <img style={{maxWidth: "75vw"}} alt="Wit Soccer Logo" src={WitSoccerLogo} />
      <DisclaimerSection>
        <H1>Pronto para começar?</H1>
        <H2>Baixe o app. Gratuito para iPhone, iPad e Android.</H2>
      </DisclaimerSection>
      <ImagesSection>
        <a href="https://play.google.com/store/apps/details?id=br.com.ioasys.witsoccer">
          <img alt="Google Play" src={GooglePlay} />
        </a>

        <a href="https://itunes.apple.com/us/app/wit-soccer/id1255285793?mt=8">
          <img alt="Apple Store" src={AppleStore} />
        </a>
      </ImagesSection>
    </Section>
  );
}
